export default "__VITE_ASSET__D0mHnAkQ__"